<div class="landing-page">
  <!-- Logo -->
  <div class="logo-container">
    <img src="../../../assets/img/safetly_image.webp" alt="Safetly Logo" loading="lazy">
  </div>

  <!-- Main Content -->
  <div class="main-content">
    <!-- Header -->
    <header class="header-section">
      <h1 class="main-title">
        {{ 'landing.title' | translate }}
      </h1>
    </header>

    <!-- Cards -->
    <div class="cards-container d-flex flex-column flex-md-row justify-content-center align-items-center">
      <!-- Left Card -->
      <div class="card card-left" (click)="onBookServices()">
        <div class="card-content">
          <div class="icon-container icon-container-left">
            <!-- Shield Icon with Checkmark -->
            <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-shield" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
            </svg>
          </div>
          <div class="text-content">
            <h2 class="card-title">{{ 'landing.book-services' | translate }}</h2>
            <p class="card-description">
              {{ 'landing.book-services-description' | translate }}
            </p>
          </div>
          <div class="features-list features-list-left">
            <span class="feature-badge feature-badge-left">
              <span class="checkmark-circle">
                <svg class="checkmark-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              </span>
              {{ 'landing.features.lightning-fast-scale' | translate }}
            </span>
            <span class="feature-badge feature-badge-left">
              <span class="checkmark-circle">
                <svg class="checkmark-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              </span>
              {{ 'landing.features.data-driven-matching' | translate }}
            </span>
            <span class="feature-badge feature-badge-left">
              <span class="checkmark-circle">
                <svg class="checkmark-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              </span>
              {{ 'landing.features.full-overview' | translate }}
            </span>
          </div>
        </div>
        <div class="shine"></div>
      </div>

      <!-- Right Card -->
      <div class="card card-right" (click)="onJoinSafetly()">
        <div class="card-content">
          <div class="icon-container icon-container-right">
            <!-- User Icon -->
            <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-right" fill="none" viewBox="0 0 24 24"
              stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
          </div>
          <div class="text-content">
            <h2 class="card-title card-title-right">{{ 'landing.take-assignments' | translate }}</h2>
            <p class="card-description card-description-right">
              {{ 'landing.take-assignments-description' | translate }}
            </p>
          </div>
          <div class="features-list features-list-right">
            <div class="features-row">
              <span class="feature-badge feature-badge-right">
                <span class="checkmark-circle checkmark-circle-right">
                  <svg class="checkmark-icon checkmark-icon-right" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-width="2.5">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                  </svg>
                </span>
                {{ 'landing.features.transparent' | translate }}
              </span>
              <span class="feature-badge feature-badge-right">
                <span class="checkmark-circle checkmark-circle-right">
                  <svg class="checkmark-icon checkmark-icon-right" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-width="2.5">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                  </svg>
                </span>
                {{ 'landing.features.simple' | translate }}
              </span>
            </div>
            <span class="feature-badge feature-badge-right feature-badge-center">
              <span class="checkmark-circle checkmark-circle-right">
                <svg class="checkmark-icon checkmark-icon-right" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  stroke-width="2.5">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              </span>
              {{ 'landing.features.secure-platform' | translate }}
            </span>
          </div>
        </div>
        <div class="shine shine-right"></div>
      </div>
    </div>
  </div>
</div>